import { render, staticRenderFns } from "./FieldInfo.vue?vue&type=template&id=4a1d39cf&scoped=true&"
import script from "./FieldInfo.vue?vue&type=script&lang=js&"
export * from "./FieldInfo.vue?vue&type=script&lang=js&"
import style0 from "./FieldInfo.vue?vue&type=style&index=0&id=4a1d39cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1d39cf",
  null
  
)

export default component.exports